var map = {
	"./1_FeliErnst_Balancel_amazon_fotografia__MG_7753.webp": "./src/img/brands/balance/1_FeliErnst_Balancel_amazon_fotografia__MG_7753.webp",
	"./FeliErnst_Balancel_amazon_fotografia_1_MG_7187.webp": "./src/img/brands/balance/FeliErnst_Balancel_amazon_fotografia_1_MG_7187.webp",
	"./FeliErnst_Balancel_amazon_fotografia__MG_6997.webp": "./src/img/brands/balance/FeliErnst_Balancel_amazon_fotografia__MG_6997.webp",
	"./FeliErnst_Balancel_amazon_fotografia__MG_7338.webp": "./src/img/brands/balance/FeliErnst_Balancel_amazon_fotografia__MG_7338.webp",
	"./FeliErnst_Balancel_amazon_fotografia__MG_7657.webp": "./src/img/brands/balance/FeliErnst_Balancel_amazon_fotografia__MG_7657.webp",
	"./FeliErnst_Balancel_amazon_fotografia__MG_7880.webp": "./src/img/brands/balance/FeliErnst_Balancel_amazon_fotografia__MG_7880.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/balance sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";